<template>
	<div class="mission">
		<table class="table-main">
			<thead>
				<tr>
					<th>이벤트번호</th>
					<th>이벤트명</th>
					<th>브랜드명</th>
					<th>제품명</th>
					<th>제출일시</th>
					<th>링크</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="(event, eventIndex) in eventList">
					<tr
						v-for="(product, pIndex) in event.productList"
						:key="eventIndex + '-' + pIndex"
					>
						<td
							v-if="pIndex === 0"
							:rowspan="event.productList.length"
						>
							{{ event.idEvent }}
						</td>
						<td
							v-if="pIndex === 0"
							:rowspan="event.productList.length"
						>
							{{ event.eventTitle }}
						</td>
						<td>{{ product.brand.brandTitle }}</td>
						<td>{{ product.productTitle }}</td>
						<td
							v-if="pIndex === 0"
							:rowspan="event.productList.length"
						>
							{{
								event.eventMission
									? formatDate(event.eventMission.updatedAt)
									: '-'
							}}
						</td>
						<td
							v-if="pIndex === 0"
							:rowspan="event.productList.length"
						>
							<div
								class="mission__link"
								v-if="
									editRowId === event.idEvent ||
									!event.eventMission
								"
							>
								<input
									type="text"
									v-model="editLinkList[event.idEvent]"
									@keyup.enter="saveLink(event.idEvent)"
								/>
								<div class="mission__link-btn">
									<button
										class="btn blue"
										@click="saveLink(event.idEvent)"
									>
										입력
									</button>
									<button
										v-if="editRowId === event.idEvent"
										class="btn red"
										@click="saveCancle"
									>
										취소
									</button>
								</div>
							</div>
							<div class="mission__link" v-else>
								<a
									:href="event.eventMission.value"
									target="_blank"
									class="link"
									>{{
										(event.eventMission &&
											event.eventMission.value) ||
										''
									}}</a
								>
								<div class="mission__link-btn">
									<button
										class="btn"
										@click="
											modifyLink(
												event.idEvent,
												(event.eventMission &&
													event.eventMission.value) ||
													'',
												$event
											)
										"
									>
										수정
									</button>
									<button
										class="btn mission__delete"
										@click="deleteLink(event.idEvent)"
									>
										X
									</button>
								</div>
							</div>
						</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>
<script>
	import dayjs from 'dayjs';

	export default {
		name: 'RegisterMissionList',
		data() {
			return {
				eventList: [],
				editRowId: null,
				editLink: '',
				editLinkList: {},
			};
		},
		computed: {},
		async mounted() {
			await this.refreshMissionList();
		},

		methods: {
			formatDate(date) {
				const formattedDate = dayjs(date).format('YYYY-MM-DD HH:mm:ss');
				return formattedDate;
			},
			modifyLink(id, currentValue, event) {
				event.stopPropagation();
				if (!confirm('수정하시겠습니까?')) return;
				this.editRowId = id;
				this.editLink = currentValue;
			},
			async saveLink(idEvent) {
				try {
					const idRegister = this.$route.params.idRegister;
					const linkValue = this.editLinkList[idEvent];
					await this.$axiosAdmin2.post(
						`/api/registers/${idRegister}/event/${idEvent}/event-mission`,
						{
							type: 'SNS_LINK',
							value: linkValue,
						}
					);
					alert('수정되었습니다.');
					this.editRowId = null;
					this.$set(this.editLinkList, idEvent, '');
					await this.refreshMissionList();
				} catch (error) {
					console.error(error);
					alert(
						'수정에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의해주세요.'
					);
				}
			},
			async refreshMissionList() {
				try {
					const data = await this.$store.dispatch(
						'mission/getMissionList'
					);
					this.eventList = data.eventList;
					this.eventList.forEach(event => {
						if (!event.eventMission) {
							this.$set(this.editLinkList, event.idEvent, '');
						}
					});
				} catch (error) {
					console.error(error);
					alert(
						'데이터를 불러오는데 실패했습니다. 지속적인 문제 발생시 개발팀에 문의해주세요.'
					);
				}
			},
			saveCancle() {
				this.editRowId = null;
				this.editLink = '';
			},
			async deleteLink(idEvent) {
				if (!confirm('삭제하시겠습니까?')) return;
				try {
					const idRegister = this.$route.params.idRegister;
					await this.$axiosAdmin2.delete(
						`/api/registers/${idRegister}/event/${idEvent}/event-mission`
					);
					alert('삭제되었습니다.');
					await this.refreshMissionList();
				} catch (error) {
					console.error(error);
					alert(
						'삭제에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의해주세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.mission {
		&__link {
			min-width: 200px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 10px;
			flex-wrap: wrap;
		}
		&__link-btn {
			display: flex;
			gap: 10px;
		}
		&__delete {
			color: red;
		}
	}
</style>
